document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.m-icon-box__description').forEach(desc => {

        const paragraphs = desc.querySelectorAll('p');

        if (paragraphs.length <= 1) return;

        for (let i = 1; i < paragraphs.length; i++) {
            paragraphs[i].classList.add('more-content');
        }

        desc.insertAdjacentHTML(
            'beforeend',
            '<a href="#" class="read-toggle">Read More</a>'
        );

        desc.querySelector('.read-toggle').addEventListener('click', function(e){
            e.preventDefault();

            desc.classList.toggle('expanded');

            this.textContent = desc.classList.contains('expanded')
                ? 'Read Less'
                : 'Read More';
        });

    });

});